import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FilterProperty } from './../../../search/filter-property';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AutomationHelpers } from '../../../automations/automation-helpers';
import { take, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { WidgetSimpleInfo } from '../../../campaign/widgets.model';

@Component({
  selector: 'app-field-autocomplete',
  templateUrl: './field-autocomplete.component.html',
  styleUrls: ['./field-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FieldAutocompleteComponent implements OnChanges {
  public autocompleteControl = new UntypedFormControl();
  filteredOptions: Observable<FilterProperty[]>;
  suggestions: any;
  @Output() selectedInput = new EventEmitter<string>();
  @Input() type;
  @Input() widgets: Array<WidgetSimpleInfo>;
  @Input()
  set data(value: FilterProperty[]) {
    if (value) {
      this.filteredOptions = this.autocompleteControl.valueChanges.pipe(
        startWith(''),
        map((val) => this.filterList(val, value)),
      );
      if (this.type === 'goals') {
        this.filteredOptions
          .pipe(
            take(1),
            tap((options) => {
              if (this.widgets && options) {
                this.suggestions = AutomationHelpers.prettifyGoalsNames(
                  this.translateService,
                  this.widgets,
                  options,
                  'displayName',
                );
                const createTooltipText = this.suggestions.map((item) => ({
                  ...item,
                  tooltip: this.removeHtmlTag(item.displayName),
                }));
                this.suggestions = createTooltipText;
              }
            }),
          )
          .subscribe();
      }
    }
  }

  @Input()
  value: string;

  @Input() operator: number;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(): void {
    this.autocompleteControl.setValue(this.value);
  }

  filterList(input, list): FilterProperty[] {
    if (input instanceof Array && list) {
      return list;
    }
    if (list && input) {
      return list.filter((item) => item.displayName.toLowerCase().indexOf(input.toLowerCase()) === 0);
    } else if (list) {
      return list;
    }
  }

  addItemfromTextField() {
    this.selectedInput.emit(this.autocompleteControl.value);
  }

  addItemfromDropdown() {
    this.selectedInput.emit(this.value);
  }

  addItemFromAutoComplete(event: MatAutocompleteSelectedEvent) {
    this.selectedInput.emit(event.option.value);
  }

  removeHtmlTag(html: string) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }
}
